import { render, staticRenderFns } from "./IdeaScoreCardPill.vue?vue&type=template&id=7a3ab185&scoped=true"
import script from "./IdeaScoreCardPill.vue?vue&type=script&lang=js"
export * from "./IdeaScoreCardPill.vue?vue&type=script&lang=js"
import style0 from "./IdeaScoreCardPill.vue?vue&type=style&index=0&id=7a3ab185&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3ab185",
  null
  
)

export default component.exports